<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        <a
          href="#"
          @click.prevent="$router.push({ name: 'schedule' })"
          class="mr-2"
        >
          <i class="fas fa-arrow-left"></i>
        </a>
        {{ className }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('schedule.pageTitle'),
            href: '/schedules'
          },
          {
            text: $t('schedule.classSchedule'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex">
          <div class="ts-flex-grow"></div>
          <div class="mr-2">
            <input
              type="text"
              v-model="dept_moeys"
              :placeholder="$t('feetype.deptMoeys')"
              class="form-control"
            />
          </div>
          <div class="mr-2">
            <div class="col-sm-12 ts-flex">
              <label class="mt-2 mr-2">{{ $t('schedule.reportType') }}</label>
              <div>
                <select
                  class="form-control"
                  style="width: 280px"
                  v-model="display_language"
                >
                  <option value>{{ $t('select') }}</option>
                  <option :value="1">{{ $t('schedule.english') }}</option>
                  <option :value="2">{{ $t('schedule.khmer') }}</option>
                </select>
              </div>
            </div>
          </div>
          <ts-button color="primary" outline @click="preview">{{
            $t('preview')
          }}</ts-button>
        </div>
      </ts-card-wrapper>
      <ts-loading-banner :loading="loading">
        <ts-table :records="aWeekChunks">
          <tr slot="thead">
            <th>{{ $t('schedule.time') }}</th>
            <th
              v-for="(wd, index) in wDays"
              :key="index"
              style="text-align: center;"
              :style="{ width: `calc(100%/${wDays.length});` }"
            >
              {{ wd.wd_name_en }}
            </th>
          </tr>
          <template slot-scope="{ record }">
            <td style="width: 1px; white-space: nowrap;vertical-align: middle;">
              <span>
                {{ record[0].schedule_time.sc_from_time }}-
                {{ record[0].schedule_time.sc_to_time }}
              </span>
              <span
                v-if="
                  record[0].schedule_time_swap !== null &&
                    record[0].schedule_time_swap.sc_from_time !== null &&
                    record[0].schedule_time_swap.sc_to_time !== null
                "
                >/ {{ record[0].schedule_time_swap.sc_from_time }}-{{
                  record[0].schedule_time_swap.sc_to_time
                }}</span
              >
            </td>
            <td
              v-for="(sd, index) in record"
              :key="index"
              style="text-align: center;vertical-align: middle;"
            >
              <a
                href="#"
                class="text-primary"
                @click.prevent="showPopUp(sd)"
                v-tooltip="$t('schedule.addSubject')"
              >
                <span v-if="sd.subject !== null">{{
                  sd.subject.subject_name
                }}</span>
                <span v-else>
                  <i class="fas fa-plus"></i>
                </span>
                <br />
                <small v-if="sd.teacher !== null"
                  >({{ sd.teacher.full_name_en }})</small
                >
                <br />
                <small v-if="sd.room !== null"
                  >{{ sd.room.room_name }}</small
                >
              </a>
            </td>
          </template>
        </ts-table>
      </ts-loading-banner>
    </ts-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ScheduleClassForm from './schedule-class-form.vue'
import PreviewSchedule from './preview-schedule'
export default {
  name: 'schedule-table',
  data() {
    return {
      dept_moeys: 'រាជធានីភ្នំពេញ',
      loading: false,
      display_language: 1
    }
  },
  created() {
    this.fetchSubjectTeacher({ acps_id: this.found_data.acps_id })
  },
  computed: {
    ...mapState('schedule', ['found_data']),

    scheduleDetails() {
      if (this.found_data === null) return []

      return _.sortBy(this.found_data.details, sd =>
        this.found_data.sch_type == 2
          ? sd.schedule_time_swap.sc_from_time
          : sd.schedule_time.sc_from_time
      )
    },
    wDays() {
      return _.sortedUniqBy(
        _.uniqBy(this.scheduleDetails.map(sd => sd.weekday), 'wd_id'),
        'wd_id'
      )
    },
    aWeekChunks() {
      return _.chunk(this.scheduleDetails, this.wDays.length)
    },
    className() {
      if (this.found_data === null) return ''

      return this.found_data.academic_class.class_name
    }
  },
  methods: {
    ...mapActions('schedule', ['fetchSubjectTeacher']),
    showPopUp(scheduleDetail) {
      ;(scheduleDetail._editing = true),
        this.$modal.show(
          ScheduleClassForm,
          {
            scheduleDetail: scheduleDetail
          },
          {
            height: 'auto',
            width: '400px',
            scrollable: true,
            draggable: '.form-header',
            clickToClose: false
          }
        )
    },
    onClassUpdated(detail, newDetailList) {
      detail._editing = false
      this.scheduleClass.details = newDetailList.map(detail => ({
        ...detail,
        _editing: false
      }))
    },
    preview() {
      this.$modal.show(
        PreviewSchedule,
        {
          sch_id: this.found_data.sch_id,
          dept_moeys: this.dept_moeys,
          display_language: this.display_language

        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  }
}
</script>
<style scoped>
.table th,
.table > tr > th {
  color: #242a30;
  font-weight: 600;
  border-bottom: 1px solid #b6c2c9 !important;
}
.ui-table th {
  background-color: #f2f3f4;
  text-transform: uppercase;
}
a {
  text-decoration: none !important;
}
</style>
